import {
  GET_ALLOCATORS_INIT,
  GET_ALLOCATORS_SUCCESS,
  GET_ALLOCATORS_FAILED,
  GET_MY_FUND_INIT,
  GET_MY_FUND_SUCCESS,
  GET_MY_FUND_FAILED,
  GET_MEETINGS_INIT,
  GET_MEETINGS_SUCCESS,
  GET_MEETINGS_FAILED,
  GET_RECENT_CHAT_INIT,
  GET_RECENT_CHAT_SUCCESS,
  GET_RECENT_CHAT_FAILED,
  GET_RECENT_POST_INIT,
  GET_RECENT_POST_SUCCESS,
  GET_RECENT_POST_FAILED,
  GET_DASHBOARD_CONFIG_INIT,
  GET_DASHBOARD_CONFIG_SUCCESS,
  GET_DASHBOARD_CONFIG_FAILED,
  UPDATE_DASHBOARD_CONFIG_INIT,
  UPDATE_DASHBOARD_CONFIG_SUCCESS,
  UPDATE_DASHBOARD_CONFIG_FAILED,
  GET_STAGE_ALLOCATION_INIT,
  GET_STAGE_ALLOCATION_SUCCESS,
  GET_STAGE_ALLOCATION_FAILED,
} from "./constants";

const initialState = {
  loading: false,
  token: null,
  getAllocators: {},
  myFundList: [],
  getRecentChat: [],
  getStageAllocation : [],
  myMeetings: [],
  recentPosts: [],
  dashboardConfigResult: [],
};

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case GET_ALLOCATORS_INIT:
      return { ...state, loading: true };
    case GET_ALLOCATORS_SUCCESS:
      return { ...state, loading: false, getAllocators: action.payload };
    case GET_ALLOCATORS_FAILED:
      return { ...state, loading: false };
    case GET_MY_FUND_INIT:
      return { ...state, loading: true };
    case GET_MY_FUND_SUCCESS:
      return { ...state, loading: false, myFundList: action.payload };
    case GET_MY_FUND_FAILED:
      return { ...state, loading: false };
    case GET_MEETINGS_INIT:
      return { ...state, loading: true };
    case GET_MEETINGS_SUCCESS:
      return { ...state, loading: false, myMeetings: action.payload };
    case GET_MEETINGS_FAILED:
      return { ...state, loading: false };
    case GET_RECENT_CHAT_INIT:
      return { ...state, loading: true };
    case GET_RECENT_CHAT_SUCCESS:
      return { ...state, loading: false, getRecentChat: action.payload };
    case GET_RECENT_CHAT_FAILED:
      return { ...state, loading: false };
    case GET_RECENT_POST_INIT:
      return { ...state, loading: true };
    case GET_RECENT_POST_SUCCESS:
      return { ...state, loading: false, recentPosts: action.payload };
    case GET_RECENT_POST_FAILED:
      return { ...state, loading: false };
    case GET_DASHBOARD_CONFIG_INIT:
      return { ...state, loading: true };
    case GET_DASHBOARD_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardConfigResult: action.payload,
      };
    case GET_DASHBOARD_CONFIG_FAILED:
      return { ...state, loading: false };
    case UPDATE_DASHBOARD_CONFIG_INIT:
      return { ...state, loading: true };
    case UPDATE_DASHBOARD_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardConfigResult: action.payload,
      };
    case UPDATE_DASHBOARD_CONFIG_FAILED:
      return { ...state, loading: false };
    case GET_STAGE_ALLOCATION_INIT:
      return { ...state, loading: true };
    case GET_STAGE_ALLOCATION_SUCCESS:
      return { ...state, loading: false, getStageAllocation: action.payload };
    case GET_STAGE_ALLOCATION_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
